import * as React from "react";
import { Stats } from '../model/index.js';
import { ANGLE_BRACKET_LEFT, ANGLE_BRACKET_RIGHT } from '../formatting.js';
export function SummaryCardBinned({ bins, decimals }) {
    const stats = React.useMemo(() => new Stats(bins.map(b => b.centre), bins.map(b => b.frequency)), [bins]);
    return (React.createElement("div", { className: "card" },
        React.createElement("p", { className: "cardTitle" }, "Anal\u00FDza rozt\u0159\u00EDd\u011Bn\u00E9ho souboru"),
        React.createElement("table", { className: "listingTable2" },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, "n"),
                    React.createElement("td", null, stats.size)),
                React.createElement("tr", null,
                    React.createElement("td", null, "min"),
                    React.createElement("td", null, stats.min.toFixed(decimals))),
                React.createElement("tr", null,
                    React.createElement("td", null, "max"),
                    React.createElement("td", null, stats.max.toFixed(decimals))),
                React.createElement("tr", null,
                    React.createElement("td", null, "varia\u010Dn\u00ED obor"),
                    React.createElement("td", null,
                        ANGLE_BRACKET_LEFT,
                        stats.min.toFixed(decimals),
                        "; ",
                        stats.max.toFixed(decimals),
                        ANGLE_BRACKET_RIGHT)),
                React.createElement("tr", null,
                    React.createElement("td", null, "varia\u010Dn\u00ED rozp\u011Bt\u00ED"),
                    React.createElement("td", null, stats.range.toFixed(decimals))),
                React.createElement("tr", null,
                    React.createElement("td", null, "pr\u016Fm\u011Br"),
                    React.createElement("td", null, stats.average.toFixed(decimals))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        "medi\u00E1n (q",
                        React.createElement("sub", null, "0.5"),
                        ")"),
                    React.createElement("td", null, stats.median.toFixed(decimals))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        "doln\u00ED kvartil (q",
                        React.createElement("sub", null, "0.25"),
                        ")"),
                    React.createElement("td", null, stats.lowerQuartile.toFixed(decimals))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        "horn\u00ED kvartil (q",
                        React.createElement("sub", null, "0.75"),
                        ")"),
                    React.createElement("td", null, stats.upperQuartile.toFixed(decimals))),
                React.createElement("tr", null,
                    React.createElement("td", null, "IQR"),
                    React.createElement("td", null, stats.iqr))))));
}
//# sourceMappingURL=SummaryCardBinned.js.map